import React from 'react';
import { Kanban, HardHat } from "@phosphor-icons/react";
import { Task, TaskPhase } from 'shared/types/task';
import { TaskKanbanView } from './TaskKanbanView';

interface TasksSectionProps {
  tasks: Task[];
  loading: boolean;
  onUpdate: () => void;
  onTaskClick: (task: Task) => void;
  onAddClick?: (phase: TaskPhase) => void;
}

export const TasksSection = React.memo(({ 
  tasks,
  loading,
  onUpdate,
  onTaskClick,
  onAddClick
}: TasksSectionProps) => {
  return (
    <div className="flex flex-col gap-3">
      {loading ? (
        <div className="flex flex-col items-center gap-4 py-12">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 border-4 border-moss-primary/20 border-t-moss-primary rounded-full animate-spin"></div>
            <HardHat weight="duotone" size={28} className="text-moss-primary animate-bounce" />
          </div>
          <div className="text-center">
            <p className="text-lg font-medium text-neutral-primary">Taken aan het laden</p>
            <p className="text-sm text-neutral-600">Even geduld terwijl we je taken ophalen...</p>
          </div>
        </div>
      ) : tasks.length === 0 ? (
        <div className="text-center py-12">
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center">
              <Kanban weight="duotone" size={32} className="text-neutral-400" />
            </div>
            <div>
              <p className="text-lg font-medium text-neutral-primary">Geen taken gevonden</p>
              <p className="text-sm text-neutral-600">Probeer andere filters of begin met het toevoegen van een nieuwe taak</p>
            </div>
          </div>
        </div>
      ) : (
        <TaskKanbanView
          tasks={tasks}
          onUpdate={onUpdate}
          onTaskClick={onTaskClick}
          onAddClick={onAddClick}
        />
      )}
    </div>
  );
});

TasksSection.displayName = 'TasksSection';

